import React from 'react';

const RegistrySummaryPrint = React.forwardRef(({ registry }, ref) => {

  return (
    <div ref={ref} className="p-6">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold">Registry Summary Report</h1>
        <p className="text-lg">Registry Closed By: {registry?.createdBy?.name ?? "Unknown User"}</p>
        <p>Date: {new Date(registry.date).toLocaleDateString()}</p>
      </div>

      <div className="mb-6 grid grid-cols-2 gap-4">
        <div className="border p-4">
          <h3 className="font-bold mb-2">Financial Summary</h3>
          <p>Opening Balance: {registry.openingBalance?.toFixed(3)}</p>
          <p>Total Sales: {registry.totalSales?.toFixed(3)}</p>
          <p>Closing Balance: {registry.closingBalance?.toFixed(3)}</p>
          <p>Cash Difference: {registry.cashDifference?.toFixed(3)}</p>
          <p>Counted Cash: {registry.countedCash?.toFixed(3)}</p>
        </div>
        
        <div className="border p-4">
          <h3 className="font-bold mb-2">Registry Information</h3>
          <p>Status: {registry.isOpen ? 'OPEN' : 'CLOSED'}</p>
          <p>Created By: {registry.createdBy?.name}</p>
          <p>Total Invoices: {registry.totalInvoices}</p>
          <p>Date: {new Date(registry.date).toLocaleString()}</p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <p>Summary generated on: {new Date().toLocaleString()}</p>
      </div>
    </div>
  );
});

export default RegistrySummaryPrint;